import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';
import { JsonPatchOperation } from '../../../definitions/json-patch-operation';

@Injectable()
export class PatchTaskFileGroupService {
  private apiUrl: string = this.configService.config.rest.apiV2Url;

  constructor(
    private client: HttpClient,
    private configService: ConfigService
  ) {}

  public patchTaskFileGroup(
    taskId: string,
    taskFileGroupId: string,
    patchDoc: JsonPatchOperation[]
  ): Observable<void> {
    const url = `${this.apiUrl}/tasks/${taskId}/task-file-groups/${taskFileGroupId}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json-patch+json',
    });

    return this.client
      .patch<void>(url, patchDoc, { headers })
      .pipe(
        catchError((error) => throwError(() => handleProblem(error)))
      );
  }
}
